// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  missionId: __t.u64().primaryKey().name("mission_id"),
  identity: __t.identity(),
  kind: __t.string(),
  targetPoi: __t.u32().name("target_poi"),
  goal: __t.u32(),
  progress: __t.u32(),
  rewardSov: __t.u64().name("reward_sov"),
  rewardXp: __t.u64().name("reward_xp"),
  state: __t.string(),
  takenAt: __t.timestamp().name("taken_at"),
});
